"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _styles = require("../styles");
var _TableContext = _interopRequireDefault(require("./TableContext"));
var _classes = require("./classes");
var _tableStyles = require("./tableStyles");
var _utils = require("./utils");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _useForkRef = _interopRequireDefault(require("@mui/material/utils/useForkRef"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["headStickyInsets", "footerStickyInsets", "bodyStickyInsets", "striped"],
  _excluded2 = ["leftStickyColumnCount", "rightStickyColumnCount", "stickyHeader", "stickyFooter", "name"];
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledMuiTable = (0, _styles.styled)(/*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ = _ref.headStickyInsets,
    __ = _ref.footerStickyInsets,
    ___ = _ref.bodyStickyInsets,
    striped = _ref.striped,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table["default"], _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-collapse: separate;\n  table-layout: ", ";\n  & .", " {\n    ", "\n  }\n\n  & .", " {\n    ", "\n  }\n\n  & .", " {\n    ", "\n  }\n\n    ", "\n  }\n"])), function (_ref2) {
  var layout = _ref2.layout;
  return layout;
}, _classes.STICKY_TABLE_HEAD, function (_ref3) {
  var headStickyInsets = _ref3.headStickyInsets;
  return (0, _tableStyles.getStickyInsetsCss)({
    stickyInsets: headStickyInsets
  });
}, _classes.STICKY_TABLE_BODY, function (_ref4) {
  var bodyStickyInsets = _ref4.bodyStickyInsets;
  return (0, _tableStyles.getStickyInsetsCss)({
    stickyInsets: bodyStickyInsets
  });
}, _classes.STICKY_TABLE_FOOTER, function (_ref5) {
  var footerStickyInsets = _ref5.footerStickyInsets;
  return (0, _tableStyles.getStickyInsetsCss)({
    stickyInsets: footerStickyInsets
  });
}, function (_ref6) {
  var striped = _ref6.striped;
  return striped && _tableStyles.tableStripedRowsCss;
});
StyledMuiTable.propTypes = {
  headStickyInsets: _propTypes["default"].object,
  footerStickyInsets: _propTypes["default"].object,
  bodyStickyInsets: _propTypes["default"].object,
  striped: _propTypes["default"].bool
};
// TODO: replace head, body, footer with rows
var Table = /*#__PURE__*/(0, _react.forwardRef)(function (_ref7, ref) {
  var _ref7$leftStickyColum = _ref7.leftStickyColumnCount,
    leftStickyColumnCount = _ref7$leftStickyColum === void 0 ? 0 : _ref7$leftStickyColum,
    _ref7$rightStickyColu = _ref7.rightStickyColumnCount,
    rightStickyColumnCount = _ref7$rightStickyColu === void 0 ? 0 : _ref7$rightStickyColu,
    stickyHeader = _ref7.stickyHeader,
    _ref7$stickyFooter = _ref7.stickyFooter,
    stickyFooter = _ref7$stickyFooter === void 0 ? true : _ref7$stickyFooter,
    name = _ref7.name,
    props = _objectWithoutProperties(_ref7, _excluded2);
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    cellCount = _useState2[0],
    setCellCount = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    tableNode = _useState4[0],
    setTableNode = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    stickyInsets = _useState6[0],
    setStickyInsets = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    columnTitles = _useState8[0],
    setColumnTitles = _useState8[1];
  var updateStickyInsetsList = (0, _react.useCallback)((0, _debounce["default"])(function (_ref8, options) {
    var _ref8$headRows = _ref8.headRows,
      headRows = _ref8$headRows === void 0 ? [] : _ref8$headRows,
      _ref8$bodyRows = _ref8.bodyRows,
      bodyRows = _ref8$bodyRows === void 0 ? [] : _ref8$bodyRows,
      _ref8$footerRows = _ref8.footerRows,
      footerRows = _ref8$footerRows === void 0 ? [] : _ref8$footerRows,
      stickyHeader = _ref8.stickyHeader,
      stickyFooter = _ref8.stickyFooter;
    setStickyInsets({
      head: (0, _utils.calcStickyPositions)(headRows, _objectSpread(_objectSpread({}, options), {}, {
        topStickyRowsCount: stickyHeader ? headRows.length : 0
      })),
      body: (0, _utils.calcStickyPositions)(bodyRows, options),
      footer: (0, _utils.calcStickyPositions)(footerRows, _objectSpread(_objectSpread({}, options), {}, {
        bottomStickyRowCount: stickyFooter ? footerRows.length : 0
      }))
    });
  }, 400), [setStickyInsets]);
  var handleRef = (0, _useForkRef["default"])(ref, setTableNode);
  (0, _react.useEffect)(function () {
    if (tableNode && cellCount && (leftStickyColumnCount || rightStickyColumnCount)) {
      var headRows = (0, _utils.getRows)(tableNode.querySelector(".".concat(_classes.STICKY_TABLE_HEAD)));
      var bodyRows = (0, _utils.getRows)(tableNode.querySelector(".".concat(_classes.STICKY_TABLE_BODY)));
      var footerRows = (0, _utils.getRows)(tableNode.querySelector(".".concat(_classes.STICKY_TABLE_FOOTER)));
      updateStickyInsetsList({
        bodyRows: bodyRows,
        headRows: headRows,
        footerRows: footerRows,
        stickyHeader: stickyHeader,
        stickyFooter: stickyFooter
      }, {
        leftStickyColumnCount: leftStickyColumnCount,
        rightStickyColumnCount: rightStickyColumnCount
      });
    }
  }, [cellCount, tableNode, leftStickyColumnCount, rightStickyColumnCount, stickyHeader, stickyFooter]);
  var getDataCy = function getDataCy() {
    return {
      'data-cy-name': name,
      'data-cy': 'Table'
    };
  };
  var getColumnTitle = function getColumnTitle(index) {
    return columnTitles[index];
  };
  var registerColumnTitle = function registerColumnTitle(index, title) {
    setColumnTitles(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, index, title));
    });
    return function () {
      setColumnTitles(function (prev) {
        var omitted = prev[index],
          other = _objectWithoutProperties(prev, [index].map(_toPropertyKey));
        return other;
      });
    };
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContext["default"].Provider, {
    value: {
      setCellCount: setCellCount,
      getColumnTitle: getColumnTitle,
      registerColumnTitle: registerColumnTitle
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMuiTable, _objectSpread(_objectSpread({}, props), {}, {
      ref: handleRef,
      headStickyInsets: stickyInsets.head,
      bodyStickyInsets: stickyInsets.body,
      footerStickyInsets: stickyInsets.footer
    }, getDataCy()))
  });
});
Table.propTypes = {
  /**
   * The content of the table, normally TableHead and TableBody.
   */
  children: _propTypes["default"].node,
  /**
   *	Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes["default"].elementType,
  /**
   * Allows TableCells to inherit padding of the Table. default is deprecated, use normal instead.
   */
  padding: _propTypes["default"].oneOf(['normal', 'checkbox', 'none', 'default']),
  /**
   * Allows TableCells to inherit size of the Table.
   */
  size: _propTypes["default"].oneOf(['small', 'medium']),
  leftStickyColumnCount: _propTypes["default"].number,
  rightStickyColumnCount: _propTypes["default"].number,
  /**
   * Set the header sticky.
   */
  stickyHeader: _propTypes["default"].bool,
  stickyFooter: _propTypes["default"].bool
};
var _default = exports["default"] = Table;